import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=56d5df5e&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d5df5e')) {
      api.createRecord('56d5df5e', component.options)
    } else {
      api.reload('56d5df5e', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=56d5df5e&", function () {
      api.rerender('56d5df5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22iLSi91dX5R6/JS/comp/seasonprices.vue"
export default component.exports